import React from 'react';
import '../styles/InlineNotice.css';
import { useInlineNotice } from '../contexts/InlineNoticeContext';

const InlineNotice = ({ scope = 'global', className = '' }) => {
  const { notices, clearInlineNotice } = useInlineNotice();
  const notice = notices?.[scope];

  if (!notice) return null;

  return (
    <div className={`inline-notice inline-notice-${notice.type} ${className}`.trim()}>
      <span className="inline-notice-message">{notice.message}</span>
      <button
        type="button"
        className="inline-notice-close"
        onClick={() => clearInlineNotice(scope)}
        aria-label="Dismiss notification"
      >
        &times;
      </button>
    </div>
  );
};

export default InlineNotice;
